/* =========================================================
   FREEBIE AUTO ADD / REMOVE

   Adds settings.freebie_product to the cart once the ELIGIBLE
   cart quantity reaches window.FREEBIE_MIN_QTY, and removes it
   again if that quantity drops back below the minimum.

   "Eligible quantity" excludes the freebie line item itself AND
   any Mystery Box bundle line item, so the two features can't
   count each other (or themselves) toward the threshold — see
   assets/mystery-box.js for the equivalent Mystery Box logic,
   which this file mirrors but does not modify.
========================================================= */

function isFreebieLineItem(item) {
  var byProp = item.properties && item.properties._freebie === "true";
  var byVariant = window.FREEBIE_VARIANT && item.variant_id === window.FREEBIE_VARIANT;
  return !!(byProp || byVariant);
}

function isMysteryBundleLineItem(item) {
  var byProp = item.properties && item.properties._mystery_bundle === "true";
  var byVariant = Array.isArray(window.MYSTERY_VARIANTS) && window.MYSTERY_VARIANTS.indexOf(item.variant_id) !== -1;
  return !!(byProp || byVariant);
}

function renderFreebieDrawerSections(sections) {
  var drawer = document.querySelector('cart-drawer');
  if (drawer && sections && sections['cart-drawer']) {
    drawer.renderContents({ sections: { 'cart-drawer': sections['cart-drawer'] } });
  }
}

var freebieEnforcing = false;

async function enforceFreebieRule(cartData) {
  if (freebieEnforcing) return;
  if (!window.FREEBIE_ENABLED || !window.FREEBIE_VARIANT) return;

  try {
    var cart = (cartData && cartData.items) ? cartData : await fetch('/cart.js').then(function (r) { return r.json(); });

    var eligibleQty = cart.items
      .filter(function (item) { return !isFreebieLineItem(item) && !isMysteryBundleLineItem(item); })
      .reduce(function (sum, item) { return sum + item.quantity; }, 0);

    var freebieItems = cart.items.filter(isFreebieLineItem);
    var hasFreebie = freebieItems.length > 0;
    var minQty = window.FREEBIE_MIN_QTY || 6;

    if (eligibleQty >= minQty && !hasFreebie) {
      freebieEnforcing = true;
      var addRes = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: [{ id: window.FREEBIE_VARIANT, quantity: 1, properties: { _freebie: 'true' } }],
          sections: 'cart-drawer',
          sections_url: window.location.pathname
        })
      });
      if (!addRes.ok) throw new Error('Freebie add failed');
      var addData = await addRes.json();
      renderFreebieDrawerSections(addData.sections);
    } else if (eligibleQty < minQty && hasFreebie && window.FREEBIE_AUTO_REMOVE) {
      freebieEnforcing = true;
      var updates = {};
      freebieItems.forEach(function (item) { updates[item.key] = 0; });
      var removeRes = await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates: updates, sections: 'cart-drawer', sections_url: window.location.pathname })
      });
      if (!removeRes.ok) throw new Error('Freebie remove failed');
      var removeData = await removeRes.json();
      renderFreebieDrawerSections(removeData.sections);
    }
  } catch (err) {
    console.error('Freebie rule enforcement error:', err);
  } finally {
    freebieEnforcing = false;
  }
}

// Same load-order defensiveness as Mystery Box: subscribe()/PUB_SUB_EVENTS
// live in pubsub.js/constants.js (loaded with `defer`), and this script may
// run before they're defined. Retry until they're available.
function registerFreebieCartWatcher() {
  if (window.__freebieCartWatcherBound) return true;
  if (typeof subscribe !== "function" || typeof PUB_SUB_EVENTS === "undefined" || !PUB_SUB_EVENTS.cartUpdate) {
    return false;
  }
  window.__freebieCartWatcherBound = true;
  subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
    enforceFreebieRule(event && event.cartData);
  });
  return true;
}

if (!registerFreebieCartWatcher()) {
  document.addEventListener("DOMContentLoaded", registerFreebieCartWatcher);
  window.addEventListener("load", registerFreebieCartWatcher);
}
